// extracted by mini-css-extract-plugin
export default {"recording_container":"MicStatus_recording_container__3m2Q6"};